import { SectionCard } from "./SectionCard";
import { FooterText } from "./FooterText";

const CardsTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS OF SERVICE FOR KEGOW DEBIT CARD
        </h2>
        <p className="text-muted mt-2">
          Please read the Terms and Conditions below carefully before requesting
          a Debit Card. If you do not accept these Terms, do not proceed.
        </p>
      </header>
      <div>
        <SectionCard
          title="1. Definitions"
          customContent={
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                1.1 <strong>"Wallet"</strong> means a wallet opened in the name
                of the wallet owner, from which payments are made under the
                conditions stated below.
              </li>
              <li className="mb-2">
                1.2 <strong>"Agreement"</strong> means this document.
              </li>
              <li className="mb-2">
                1.3 <strong>"Authorization"</strong> means confirmation given to
                a Merchant, Bank or Automatic Teller Machine (ATM) for card
                transaction initiated by the card holder.
              </li>
              <li className="mb-2">
                1.4 <strong>"Card"</strong> means Kegow Debit Card issued under
                the Card Association payment scheme.
              </li>
              <li className="mb-2">
                1.5 <strong>"Card Number"</strong> means the number embossed
                across the middle of the card.
              </li>
              <li className="mb-2">
                1.6 <strong>"PIN"</strong> means Personal Identification Number
                issued to or selected by you or any Additional Cardholder.
              </li>
              <li className="mb-2">
                1.7 <strong>"Merchant"</strong> means a person or business who
                agrees to accept the Card as payment for goods, services, or
                cash.
              </li>
              <li className="mb-2">
                1.8 <strong>"Transaction"</strong> means any use of the Card or
                Card Number to make or authorize payments to a Merchant, or the
                use of the Card and PIN in ATMs to obtain cash.
              </li>
              <li className="mb-2">
                1.9 <strong>"Card Association"</strong> means the card brand and
                platform your card is issued on, such as MasterCard, Visa,
                Interswitch, eTranzact, or Afrigo.
              </li>
              <li className="mb-2">
                1.10<strong>"We", "Ours", "Us"</strong> means Chamsmobile Ltd
                (Kegow).
              </li>
              <li className="mb-2">
                1.11<strong>"You/Your"</strong> means the customer(s) to whom a
                Card is issued by us.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="2. Use of Card"
          customContent={
            <>
              <p>
                2.1 You must ensure that all Cards are signed immediately upon
                receipt and that you comply with any instructions we provide
                regarding the use and safekeeping of Cards.
              </p>
              <p>2.2 You may only use the Card:</p>
              <ul className="ms-4">
                <li>2.2.1 Within the validity period embossed on the Card</li>
                <li>
                  2.2.2 In accordance with applicable laws and regulations
                </li>
              </ul>
              <p>
                2.3 You may not use the Card for any unlawful or prohibited
                purpose.
              </p>
              <p>
                2.4 Subject to{" "}
                <a href="#clause-10" className="text-decoration-none fw-bolder">
                  Clause 10
                </a>
                , you will be liable for the amount of all Card Transactions and
                Charges debited to your wallet.
              </p>
              <p>
                2.5 You must exercise reasonable care when providing your Card
                details to a Merchant to ensure the integrity of the Merchant
                and to prevent unauthorized continuous debiting.
              </p>
              <p>
                2.6 You may use the Card to withdraw cash from any ATM
                displaying the Card Association's symbol worldwide.
              </p>
              <p>
                2.7 We will issue you a Personal Identification Number (PIN). We
                will not give your PIN to anyone other than you. You may use
                your PIN with your Card to withdraw cash and access other
                services at self-service machines. You may also be required by a
                Merchant or supplier to enter your PIN into a secure PIN pad
                when paying for goods or services.
              </p>
              <p>
                2.8 We may refuse to authorize a payment if we believe your Card
                or Wallet has been, or is likely to be, misused. We may refer an
                authorization request back to the Merchant or supplier for
                additional information. You may be asked to provide further
                identification.
              </p>
              <p>
                2.9 You cannot stop a Card payment once it has been authorized.
                However, a Merchant may initiate a refund. We will credit your
                Wallet when we receive any such refund. We cannot be held
                responsible for any delay in receiving the refund.
              </p>
            </>
          }
        />

        <SectionCard
          title="3. Safeguarding the Card and PIN"
          customContent={
            <>
              <p>
                3.1 You must take all possible steps to keep the Card safe and
                all card security details secret at all times.
              </p>
              <p>
                3.2 You must take reasonable precautions to prevent fraudulent
                use of your Card and PIN. These include:
              </p>
              <ul className="ms-4">
                <li>
                  3.2.1 Shielding the keypad at self-service machines or secure
                  PIN pads when entering your PIN.
                </li>
                <li>
                  3.2.2 Not choosing a PIN that is easy to guess (e.g., 123456,
                  your date of birth, or phone number).
                </li>
                <li>
                  3.2.3 Complying with all reasonable instructions we issue
                  about keeping your PIN safe.
                </li>
              </ul>
              <p>
                3.3 You must never allow another person to use your Card or PIN.
                If you do, you will be liable for all debits to your Wallet.
              </p>
              <p>
                3.4 You must never write the PIN on the card or on any material
                kept with the card.
              </p>
              <p>
                3.5 You may only disclose the card number for the purpose of
                making a valid transaction, reporting loss or theft or where we
                authorize disclosure.
              </p>
              <p>
                3.6 When paying online, you are strongly advised to use secure
                payment sites and software.
              </p>
              <p>
                3.7 You must inform us immediately if you notice any
                unrecognized transactions on your statement.
              </p>
              <p>
                3.8 You must report any lost or stolen card as soon as
                practicable (
                <a href="#clause-10" className="text-decoration-none fw-bolder">
                  see Clause 10.1
                </a>
                ).
              </p>
            </>
          }
        />

        <SectionCard
          title="4. Card Transaction"
          customContent={
            <>
              <p>
                4.1 The Card or Card Number may be used to make or authorize
                payments to Merchants who accept the Card. The PIN may be used
                to withdraw cash at ATMs that accept the Card.
              </p>
              <p>
                4.2 Once a transaction has been authorized, it cannot be
                stopped.
              </p>
              <p>
                4.3 Some transactions may require our authorization before
                completion. Once authorized, the transaction amount will be
                reserved against your Wallet balance. We may refuse any
                authorization request at our discretion.
              </p>
            </>
          }
        />

        <SectionCard
          title="5. The Mobile Wallet"
          customContent={
            <>
              <p>
                5.1 Your Mobile Wallet is governed by our Personal or Business
                Banking Terms and Conditions. If there is a conflict, these
                Debit Card Terms and Conditions shall prevail.
              </p>
              <p>
                5.2 All Card transactions will be deducted from your Wallet.
              </p>
              <p>
                5.3 If you owe us money, we may, without further consent, debit
                your account.
              </p>
              <p>
                5.4 Once a transaction is authorized, the available balance will
                be reduced immediately, even if the debit has not yet been
                processed.
              </p>
              <p>
                5.5 If an authorization is given by us, the card transaction
                will immediately reduce the amount which can be drawn on the
                account, even though the amount has not been deducted from the
                account by then.
              </p>
            </>
          }
        />

        <SectionCard
          title="6. Payments"
          customContent={
            <p>
              6.1 Transactions will normally be debited within five (5) working
              days. All transactions will appear in your transaction history and
              statement.
            </p>
          }
        />

        <SectionCard
          title="7. Fees and Charges"
          customContent={
            <>
              <p>7.1 We apply charges for the following:</p>
              <ul className="ms-4">
                <li>7.1.1 A one-time Debit Card issuance fee of ₦1,050.</li>
                <li>
                  7.1.2 In addition to the issuance fee,{" "}
                  <strong>
                    you shall bear all delivery and dispatch charges
                  </strong>{" "}
                  incurred in sending the Debit Card to your designated address
                  or pickup location.
                </li>
                <li>7.1.3 ATM withdrawals using the Mobile Wallets.</li>
                <li>7.1.4 Transactions made using the Mobile Wallet.</li>
              </ul>
              <p>
                7.2 These charges are set out in our published tariff of
                charges, available when you open your Wallet and on our website:{" "}
                <a
                  href="www.kegow.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  our website
                </a>
                . The tariff also lists additional fees for certain services not
                specific to Card usage.
              </p>
              <p>
                7.3 We reserve the right to change our charges. Where required,
                we will notify you at least thirty (30) days in advance.
              </p>
            </>
          }
        />

        <SectionCard
          title="8. Use of Information"
          customContent={
            <>
              <p>
                8.1 We will comply with applicable data protection laws
                regarding information we hold about you.
              </p>
              <p>
                8.2 We may share your information with organizations involved in
                processing your application, payments, or transactions.
              </p>
              <p>
                8.3 We may retain your information after your Wallet is closed,
                as required by law.
              </p>
              <p>
                8.4 We will contact you via the same medium you used to contact
                us (e.g., email, phone, or post). If you wish not to be
                contacted in a specific way, you must notify us.{" "}
              </p>
            </>
          }
        />

        <SectionCard
          title="9. Termination"
          customContent={
            <>
              <p>9.1 We may without notice:</p>
              <ul className="ms-4">
                <li>9.1.1 Refuse to authorize transactions.</li>
                <li>
                  9.1.2 Cancel or suspend your right to use the Card in whole or
                  in part.
                </li>
                <li>
                  9.1.3 Refuse to replace any Card, without affecting your
                  obligations under this Agreement.
                </li>
              </ul>
              <p>
                9.2 We are not responsible if a request for authorization is
                declined or if a card is not accepted in payment or for any loss
                or damage resulting from the way in which either decision is
                communicated to you.
              </p>
              <p>
                9.3 You may terminate use of the Card at any time by notifying
                us and returning the Card(s), which must be destroyed by cutting
                through the magnetic strip and chip.
              </p>
              <p>
                9.4 We may reissue Cards periodically, in accordance with this
                Agreement, until it is terminated.
              </p>
            </>
          }
        />

        <SectionCard
          title="10. Loss or Misuse of Card and Liability"
          customContent={
            <>
              <p id="clause-10.1">
                10.1 If your Card is lost, stolen, or at risk of misuse, or your
                PIN has been compromised, you must immediately contact us on
                +234 807 966 4791.
              </p>
              <ul className="ms-4">
                <li>
                  10.1.1 Provided you have not acted fraudulently or without
                  reasonable care, you will not be liable for: (a) Transactions
                  made before you received your Card. (b) Transactions made more
                  than 60 minutes after you report your Card lost or stolen.
                </li>
              </ul>
              <p>10.2 You shall be liable:</p>
              <ul className="ms-4">
                <li>
                  10.2.1 If your Card is lost, stolen, or misused due to your
                  negligence.
                </li>
                <li>10.2.2 If it is misused with your permission.</li>
                <li>
                  10.2.3 If it is fraudulently used before you report it lost or
                  stolen.
                </li>
                <li>
                  10.2.4 For consequences arising from disclosure of information
                  to third parties.
                </li>
                <li>
                  10.2.5 For loss or damage from the use of terminals accepting
                  the Card.
                </li>
              </ul>
              <p>
                10.3 Cards recovered after being reported lost or stolen must
                not be used and must be cut in half and returned to us.
              </p>
              <p>
                10.4 You must cooperate with us and law enforcement in
                recovering a lost or stolen Card. If you recover the Card, do
                not use it; cut it in half and return it.
              </p>
              <p>
                10.5 If you claim an unauthorized transaction, we may require
                you to report it to the police and provide a crime reference
                number before we issue a refund.
              </p>
              <p>
                10.6 You are not liable for non-receipt of a Card unless it was
                caused by your failure to update your address.
              </p>
              <p>
                You agree to provide us with all information related to loss,
                theft, or misuse of the Card and to cooperate with our recovery
                efforts.
              </p>
            </>
          }
        />

        <SectionCard
          title="11. Limitation of Liability"
          customContent={
            <>
              <p>
                11.1 Until you notify us under{" "}
                <a href="#clause-10" className="text-decoration-none fw-bolder">
                  Clause 10
                </a>
                , you remain liable for all transactions made up to 60 minutes
                after such notification.
              </p>
              <p>
                11.2 If someone uses your Card with your permission, you are
                liable for all transactions until you notify us.
              </p>
              <p>
                11.3 You will not be liable for transactions made more than 60
                minutes after notifying us that your Card is lost or stolen.
              </p>
              <p>
                11.4 If we cannot debit your account due to closure or other
                reasons beyond our control, you remain liable for the
                transaction amount.
              </p>
              <p>
                11.5 We will not be liable if we cannot fulfill our obligations
                due to circumstances beyond our reasonable control:
              </p>
              <ul className="ms-4">
                <li>11.5.1 Machine failure.</li>
                <li>
                  11.5.2 Industrial disputes, natural disasters, or acts of God.
                </li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="12. Ownership of the Card"
          customContent={
            <p>
              12.1 The Card remains the property of Chamsmobile Ltd at all times
              and must be returned immediately upon request.
            </p>
          }
        />

        <SectionCard
          title="13. General"
          customContent={
            <>
              <p>
                13.1 These Terms and Conditions are in addition to the Terms and
                Conditions governing your Wallet. If there is a conflict, these
                Debit Card Terms and Conditions shall prevail.
              </p>
              <p>
                13.2 We may amend these Terms and Conditions from time to time
                with at least 30 days’ notice, except where changes are
                beneficial to you.
              </p>
              <p>
                13.3 We are not liable for failure to perform our obligations
                due to circumstances beyond our control.
              </p>
              <p>
                13.4 If a Merchant is required to refund a transaction, we will
                credit your Wallet only after receiving the refund. You cannot
                transfer claims against a third party to us.
              </p>
              <p>
                13.5 This Agreement is effective once all required documentation
                has been completed and received by us.
              </p>
              <p>
                13.6 You must notify us immediately of any change in your name
                or address.
              </p>
              <p>
                13.7 We may assign our rights under this Agreement at any time.
              </p>
              <p>
                13.8 This Agreement is governed by the laws of the Federal
                Republic of Nigeria.
              </p>
              <p>
                13.9 Failure or delay in enforcing any condition does not waive
                our right to enforce it later.
              </p>
              <p>
                13.10 For your security, we may record phone calls between you
                and us.
              </p>
              <p>
                13.11 Your application is subject to internal regulatory
                processes and reviews. We reserve the right to accept or reject
                your application.
              </p>
            </>
          }
        />

        <SectionCard
          title="Important Note"
          customContent={
            <p>
              Cards not activated within six (6) months of issuance will be
              blocked. Customers will be required to request a new Card to
              continue using their Debit Card account.
            </p>
          }
        />

        <SectionCard
          title="Acknowledgement"
          customContent={
            <>
              <p className="fw-bold text-dark">
                Having read and understood the above{" "}
                <strong>Chamsmobile Ltd Debit Card Terms and Conditions</strong>
                , I hereby consent to be bound by these Terms and Conditions.
              </p>
            </>
          }
        />

        <FooterText
          supportText="For inquiries or customer support, please contact Kegow customer service through the official app channels."
          lastUpdated="August 20, 2025."
          termsText=" Chamsmobile Ltd Debit Card Terms and Conditions."
        />
      </div>
    </div>
  );
};

export default CardsTermsAndConditions;
